import React from "react";
import styled from "styled-components";
import src_video from "../assets/solarpv_short.mp4"
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useAcceptDisclaimerMutation } from "../store/apis/userApi";
import { setUser } from "../store/slices/authSlice";

export default function Disclaimer () {
    const navigate = useNavigate();
    const dispatch = useDispatch();
   
    const user = JSON.parse(sessionStorage.getItem("user")) || null;
    
    const [acceptDisclaimer, { isLoading, isError }] = useAcceptDisclaimerMutation();

    const handleAccept = async () => {
        try {
            const payload = {
                name: user.name || "",
                email: user.email || "",
                photo: user.photo || "",
                organisation: user.organisation || "",
                disclaimer: true, // ✅ accepting
                demo_user: user.demo_user ?? false,
                accept_agreement: user.accept_agreement ?? false,
            };

            const data = await acceptDisclaimer(payload).unwrap();
           
            // Update Redux state instantly
            const updatedUser = { ...user, disclaimer: true };
            dispatch(setUser(updatedUser));
            
            navigate("/login");
        } catch (error) {
            console.error("Error accepting disclaimer:", error);
            navigate("/signupv2");
        }
    };

    const handleSkip = () => {
        alert("You need to accept the disclaimer to continue further");
        navigate("/disclaimer");
    };

    return (
        <Container>
            <div className="container">
                <div className="title">
                    <h1> Disclaimers and Important information </h1>                
                </div>
                <h5> SolarAIDD is in its initial beta-testing stage and further development and improvement is planned. </h5>
                <div className="disclaimers">
                    <div className="info-box">
                        <h5> Uploading EL images </h5>
                        <h6> A user can upload a maximum of 15 batches at a time. Should the user wish to upload more, older batched must be 
                            deleted first using the Delete button on the View analysis page.  </h6>
                        <h6> The system expects batches of EL images to be uploaded. The number of EL images per batch must be between 1-40. 
                            The system also assumes that the panel is centred in the frame and no distortions or noise are present. </h6>
                        <h6> For batches containing half-cut cell modules, please enter the number of half cell rows and columns. </h6>
                    </div> 
                    <div className="info-box">
                        <h5> Upload and processing speed </h5>
                        <h6> The system process images in the backgound and can take several minutes. While a batch is being processed, you are free to view
                            any other page. </h6>
                        <h6>Note that the system processess one batch at a time and that it will not allow you to upload another 
                            batch while the current batch is being processed. </h6>
                    </div>        
                </div>   
                <div className="video-box">
                    <div className="subtitle">
                        <h5> Please watch the video for a short demonstration on how to use the system. </h5>
                    </div>                    
                    <video width="100%" height="100%" controls>
                        <source src={src_video} type="video/mp4" />
                    </video>
                </div>  
                <div className="button-box">
                    <button onClick={handleAccept}> Accept and continue </button>
                    <button onClick={handleSkip}> Skip </button>
                </div>    
            </div>           
        </Container>
    )
}

const Container = styled.div`
background: white;
.container {
    position: absolute;
    top: 2rem;
    left: 0;
    width: 100vw;
    color: black;
    background: white;
    display: flex;  
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    h6 {
        font-weight: normal;
    } 
    .title {
        padding: 0.5 rem;
        text-align: center;     
    }
    .video-box {
        text-align: center;
        width: 30vw;
        display: flex;  
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        .subtitle {            
            padding: 0.5rem;
        }
        Video {
            max-width: 100%;
            max-height: 100%;
        }
    }
    .disclaimers {        
        width: 90vw;
        display: flex;  
        flex-direction: row;
        align-items: top;
        justify-content: space-between;
        gap: 1rem; 
        .info-box {
            border-radius: 5px;
            box-shadow: rgba(0, 0, 0, 0.75) 0px 3px 10px;
            width: 50vw;
            display: flex;  
            flex-direction: column;
            gap: 0.5rem;
            align-items: left;            
            text-align: left;
            padding: 0.5rem;
        }
    }
    .button-box {
        width: 40vw;
        display: flex;  
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 1rem; 
        button {
            padding: 0.5rem 1rem;
            background-color: #E55B41;
            border: none;
            cursor: pointer;
            color: white;
            border-radius: 0.2rem;
            font-weight: bolder;
            font-size: 1.05rem;
          }
    }
}
`